import { Injectable, inject } from "@angular/core";
import { QuestionReportCategory } from "../classes/flow/Questionnaire/Question";
import { EpfService } from "./epf.service";

@Injectable({
  providedIn: "root",
})
export class ReportCategoryService {
  private epf = inject(EpfService);

  public async addQuestionReportCategory(questionID: number, reportCategoryID: number): Promise<QuestionReportCategory> {
    return this.epf.addQuestionReportCategory(questionID, reportCategoryID);
  }

  public async deleteQuestionReportCategory(qrc: QuestionReportCategory): Promise<void> {
    return this.epf.deleteQuestionReportCategory(qrc);
  }
}
